<template>
  <div>
    <div class="flex items-center mb-4">
      <span
        class="text-grey-darker mr-2 text-2xl cursor-pointer"
        @click="$router.push({name: 'dashboard'})"
      >Veranstaltungen</span>
      <font-awesome-icon icon="chevron-right"></font-awesome-icon>
      <span class="text-3xl ml-2" v-text="event.title"></span>
    </div>
    <div class="mb-8">
      <div class="flex">
        <span class="item-center mr-2 text-gray-900">
          <font-awesome-icon icon="calendar"></font-awesome-icon>
        </span>
        <span class="item-center">{{event.start_date | date}} Uhr</span>
      </div>

      <div>
        <span class="item-center mr-2 text-gray-900">
          <font-awesome-icon icon="map-marker-alt"></font-awesome-icon>
        </span>
        <span>{{event.venue.name}} - {{event.venue.city}}</span>
      </div>
    </div>

    <div class="mb-20 rounded-xl border overflow-hidden">
      <iframe
        class="border-0"
        width="100%"
        height="370"
        frameborder="0"
        style="border:0"
        :src="`https://www.google.com/maps/embed/v1/place?key=${mapKey}&q=${address}`"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>


<script>
import dayjs from "dayjs";
export default {
  props: ["event"],
  filters: {
    date(value) {
      return dayjs(value).format("dddd, DD MMMM YYYY HH:mm");
    }
  },

  computed: {
    address() {
      let name = this.event.venue.name.replace(" ", "+");
      let street = this.event.venue.street.replace(" ", "+");
      let city = this.event.venue.city.replace(" ", "+");

      return `${name},+${street},+${city}`;
    },

    mapKey() {
      return process.env.VUE_APP_GOOGLE_MAPS_KEY;
    }
  }
};
</script>